import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => {
  const styles: StyleRules = {
    container: {
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'inline-flex',
      padding: '8px 18px',
      position: 'relative',
      width: '100%',
      '& span': {
        fontWeight: 500,
      },
    },
    circle: {
      width: 7,
      height: 7,
      background: '#039BE5',
      borderRadius: 50,
      marginRight: 10,
    },
  };

  return styles;
});
